import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { LocalStorageKey } from '@ddt-web/generic-utils';
import { GOALS_CONFIG_RESPONSE, STRATEGIES_CONFIG_RESPONSE, STRATEGIES_RULES_ENGINE_CONFIG_RESPONSE } from '@test-data/dummy-backend-data/cma-goal-and-strategies';
import { Observable, of } from 'rxjs';

@Injectable()
export class CmaInterceptorService implements HttpInterceptor {
	// set to true to use the the local goals and strategies config
	private debugMode: boolean = false;

	public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const isGoalAndStrategyRequest = request.url.includes('goals') || request.url.includes('strategies');

		if (window.location.href.includes('debugMode=true')) {
			localStorage.setItem(LocalStorageKey.CmaDebug, 'true');
		} else if (window.location.href.includes('debugMode=false')) {
			localStorage.removeItem(LocalStorageKey.CmaDebug);
		}

		const isDebugMode = isDevMode && (this.debugMode || !!localStorage.getItem(LocalStorageKey.CmaDebug));
		if (isDebugMode && isGoalAndStrategyRequest) {
			return this.getMockGoalsAndStrategyResponse(next, request);
		}

		return next.handle(request);
	}

	private getMockGoalsAndStrategyResponse(next: HttpHandler, request: HttpRequest<any>): any {
		let body = {};

		if (request.url.includes('strategies-rules-engine')) {
			console.warn('Using mock data for strategies rules engine.');
			body = STRATEGIES_RULES_ENGINE_CONFIG_RESPONSE;

		} else if (request.url.includes('goals')) {
			console.warn('Using mock data for goals.');
			body = GOALS_CONFIG_RESPONSE;

		} else if (request.url.includes('strategies')) {
			console.warn('Using mock data for strategies.');
			body = STRATEGIES_CONFIG_RESPONSE;
		}

		const response = new HttpResponse({ body: body });
		console.log('Intercepting response', response);

		return of(response);
	}
}
